import React from 'react'
import { NavbarTwo } from '../components/Layout/Navbar'
import Research from '../components/About/Research'
import Footer from '../components/Layout/Footer'

const ResearchPage = () => {
  return (
    <div>
        <NavbarTwo />
        <div className='2xl:pt-[120px] pt-[80px] xl:pt-[110px] lg:pt-[100px]'>
        <Research />
        <Footer />
        </div>
    </div>
  )
}

export default ResearchPage